import MasonryGrid from '../components/MasonryGrid';

export default class StaticBlogMasonry {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.$masonry = this.$el.find('[data-masonry-grid]');

    this.masonryGrid = new MasonryGrid({
      $el: this.$masonry
    });
  }

  onSectionUnload() {
    return this.masonryGrid.unload();
  }
}

